import React, { useState, useContext, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import { useTranslation } from "react-i18next";
import { Tooltip, CircularProgress } from "@mui/material";
import "../../styles/components/Editor.scss";
import "../../styles/components/EditorModal.scss";
import ErrComponentToRender from "../../Uitls/apiErrorHandling";
import DropDownWithLabelTemplate from "../DropDownWithLabelTemplate.js";
import Switch from "@mui/material/Switch";
import warning from "../../images/warning.svg";

import {
  getNewBrandsAndcampaigns,
  getAssetdetails,
  getMarketList,
  getSizesData,
  getBannerdetailsfromVeeva,
  saveEmail,
  createOnetimeBanner,
} from "../../services/apis";
import { toast } from "react-toastify";
import { nameValidation } from "../../Uitls/Util";
import ValueContext from "../../ContextAPi/appContext";
import Button from "@mui/material/Button";
import { numericBannerSizes } from "../../Uitls/RightPanelToolBarItems";
import SizeDropdown from "../SizeDropdown.js";

export default function NewBannerModal(props) {
  const history = useHistory();
  const { showNewBanner, setShowNewBanner, setopenModalOnLoad } = props;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type");
  const docid = queryParams.get("docid");
  const product = queryParams.get("product");
  const productName = queryParams.get("productName");
  const country = queryParams.get("country");
  const appData = useContext(ValueContext);
  const [brandsAndCampaigns, setBrandsAndCampaigns] = useState([]);
  const [marketDataSource, setMarketDataSource] = useState([]);
  const [selectedMarket, setSelectedMarket] = useState(undefined);
  const [loader, setLoader] = useState(false);
  const [bannerSize, setbannerSize] = useState([]);
  const [selectOnetimecontent, setSelectOnetimecontent] = useState(true);

  const [genericInfo, setGenericInfo] = useState({
    brand: "",
    campaign: "",
    market: "",
    bannerNameInput: "",
    bannerSize: "",
    bannerSizeType: "Pre-defined",
    Width: 0,
    Height: 0,
    bannerType: "",
    promomatTempDocId: "ES-BVY-0064",
  });
  const [selectedMarketName, setselectedMarketName] = useState({});
  const [selectedBrandName, setselectedBrandName] = useState({});
  const [disableSize, setdisableSize] = useState(true);
  const [selectedSizes, setselectedSizes] = useState([]);
  const bannerType = ["Static Banner", "Animated Banner"];
  const textRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const { t } = useTranslation();
  let queryObj = {
    type: type,
    promomatsDocId: docid,
    brand: product,
    brandName: productName,
    country: country,
  };
  let createdByName = localStorage.getItem("currentUserName") || "-";
  let createdByEmail = localStorage.getItem("userEmail") || "-";

  const date = new Date();
  const formattedDate = date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const closeNewBannerModal = (e) => {
    setShowNewBanner(false);
    setLoader(false);
  };

  const handleFormReset = () => {
    setGenericInfo({
      brand: "",
      campaign: "",
      market: "",
      bannerNameInput: "",
      bannerSize: "",
      bannerType: "",
      width: 0,
      height: 0,
    });
    setSelectedMarket("");
  };

  useEffect(() => {
    setGenericInfo({ ...genericInfo, campaign: "" });
  }, [genericInfo.brand]);

  useEffect(() => {
    fetchAllSizesBanner();
    fetchBrandsAndCampaigns();
    fetchMarketData();
  }, []);

  const fetchBrandsAndCampaigns = () => {
    getNewBrandsAndcampaigns((response, err, errCode) => {
      if (err) {
        const errCoponent = ErrComponentToRender(errCode);
        toast.error(errCoponent);
        setselectedBrandName({});
      } else {
        const data = response.data;
        if (data && data.length > 0) {
          let sortedData;
          sortedData = data.slice().sort((a, b) => {
            const brandNameA = a.brandName.trim().toUpperCase();
            const brandNameB = b.brandName.trim().toUpperCase();
            return brandNameA.localeCompare(brandNameB, "en", {
              sensitivity: "base",
            });
          });

          sortedData = [...sortedData].map((data) => {
            let object = data;
            object["displayName"] = `${object.brandName}`;
            return object;
          });
          setBrandsAndCampaigns(sortedData);
          let selectedBrand = data?.find((item) => {
            return item?.brandDamId === queryObj?.brand;
          });
          setselectedBrandName(selectedBrand);
        } else {
          setselectedBrandName({});
        }
      }
    });
  };

  function validateForm() {
    return (
      genericInfo.bannerType?.length > 0 &&
      (genericInfo.bannerSize?.length > 0 ||
        (genericInfo.Width > 0 && genericInfo.Height > 0))
    );
  }

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "bannerNameInput") {
      if (value.length > 250) {
        toast.error(
          <div className="notificationText">
            Banner name cannot exceed 250 characters.
          </div>,
          { autoClose: 1200, hideProgressBar: false },
        );
        return;
      }
      if (value.includes(" ")) {
        toast.error(
          <div className="notificationText">
            Banner name cannot contain spaces.
          </div>,
          { autoClose: 1200, hideProgressBar: false },
        );
        return;
      }
    }

    setGenericInfo({ ...genericInfo, [name]: value });

    if (brandsAndCampaigns) {
      brandsAndCampaigns.forEach((brand) => {
        if (brand.brandName === value) {
          appData.setBrandId(brand.brandDamId);
        }
        brand.campaigns.forEach((campaign) => {
          if (campaign.campaignName === value) {
            appData.setCampaignId(campaign.campaignId);
          }
        });
      });
    }
  };
  const fetchMarketData = () => {
    getMarketList((response, err, errCode) => {
      if (err) {
        const errCoponent = ErrComponentToRender(errCode);
        toast.error(errCoponent);
        setselectedMarketName({});
      } else {
        const data = response.data;
        if (data) {
          let marketData = data;
          if (marketData && marketData.length > 0) {
            marketData = [...marketData].map((market) => {
              let object = {
                code: market.countryDamId,
                shortName: market.ShortName,
                name: market.marketName,
              };
              object["displayName"] = `${object.name}`;
              let filteredMarket = data.find((item) => {
                return item.countryDamId === queryObj.country;
              });
              setselectedMarketName(filteredMarket);
              return object;
            });
            if (marketData && marketData.length > 0) {
              marketData = [...marketData].sort((marketOne, marketTwo) => {
                if (marketOne.name < marketTwo.name) {
                  return -1;
                }
                if (marketOne.name > marketTwo.name) {
                  return 1;
                }
                return 0;
              });
              setMarketDataSource(marketData);
            }
          }
        } else {
          setselectedMarketName({});
        }
      }
    });
  };

  const fetchAllSizesBanner = () => {
    getSizesData(queryObj?.promomatsDocId, (response, err) => {
      if (response.status === 200) {
        setdisableSize(false);
        let array = [];
        if (response?.data) {
          for (const key in response.data) {
            const element = response.data[key];
            array.push(element);
          }
          setselectedSizes(array);
        } else {
          setselectedSizes(array);
        }
      } else {
        toast.error(
          <div className="notificationText">
            {`Failed to fetch available banner sizes for current Veeva Document Number.`}
          </div>,
        );
      }
    });
  };

  const handleGoToEditorScreen = (moduleInfo) => {
    fetchAllSizesBanner();
    const isBannerAlreadyCreated = Object.keys(selectedSizes).length !== 0;
    if (isBannerAlreadyCreated) {
      setopenModalOnLoad(false);
      setShowNewBanner(false);
      toast.error(
        <div className="notificationText">Banner Already Created.</div>,
      );
      return;
    }

    if (!nameValidation(genericInfo.bannerNameInput, "Banner")) return;
    if (!selectedBrandName?.brandDamId || !selectedMarketName?.countryDamId) {
      const errorMessage =
        !selectedBrandName?.brandDamId && !selectedMarketName?.countryDamId
          ? `Both Product : ${queryObj?.brand} and Country : ${queryObj?.country} selected in Veeva Vault does not exist in Content Studio.`
          : !selectedBrandName?.brandDamId
            ? `Product : ${queryObj?.brand} selected in Veeva Vault does not exist in Content Studio.`
            : `Country : ${queryObj?.country} selected in Veeva Vault does not exist in Content Studio.`;

      toast.error(<div className="notificationText">{errorMessage}</div>);
      return;
    }

    setLoader(true);
    appData.setActiveCards([]);
    var moduleInfo = {};
    moduleInfo.assetType = "BANNER";
    moduleInfo.brandName = selectedBrandName?.brandName;
    moduleInfo.campaign = genericInfo.campaign;
    moduleInfo.campaignId = appData?.campaignId;
    moduleInfo.brandId = selectedBrandName?.brandDamId;
    moduleInfo.marketCode = selectedMarketName?.countryDamId;
    moduleInfo.marketName = selectedMarketName?.marketName;
    moduleInfo.comments = "";
    moduleInfo.description = "";
    moduleInfo.modules = [];
    moduleInfo.attributes = {
      custom: genericInfo?.bannerSizeType === "Custom",
    };
    moduleInfo.attributes = {
      customTemp: genericInfo?.bannerSizeType === "Custom" ? true : false,
    };
    moduleInfo.isAnimated =
      genericInfo.bannerType === "Animated Banner" ? true : false;
    moduleInfo.damDocNumber = queryObj?.promomatsDocId;
    appData.setCustomTempSize(
      genericInfo?.bannerSizeType === "Custom" ? true : false,
    );

    const getAssetDetailsAsync = (moduleInfo) => {
      return new Promise((resolve, reject) => {
        getAssetdetails(moduleInfo, (response, err, errorCode) => {
          if (err) {
            reject({ err, errorCode });
          } else {
            resolve(response);
          }
        });
      });
    };

    let arr = [];

    for (let i = 0; i < genericInfo?.bannerSize?.length; i++) {
      const match = genericInfo.bannerSize[i].match(/\d{2,4}×\d{2,4}/);
      if (match) {
        const [width, height] = match[0].split("×");
        let payload = {
          ...moduleInfo,
          width,
          height,
          assetName: `${genericInfo.bannerNameInput.trim()}_${width}x${height}`,
        };
        if (!nameValidation(payload.assetName, "Banner")) {
          setLoader(false);
          return;
        }
        arr.push(getAssetDetailsAsync(payload));
      }
    }

    // Promise.all(arr)
    //   .then((responses) => {
    //     setGenericInfo(responses[0].data);
    //     appData.updateGenericInfo({
    //       ...appData?.genericInfo,
    //       ...responses[0].data,
    //     });

    //     const createdAssetId = responses?.[0]?.data?.assetId;
    //     const email = window.localStorage.getItem("userEmail");
    //     if (createdAssetId && email) {
    //       const payload = {
    //         assetId: createdAssetId,
    //         email,
    //         update: false,
    //       };

    //       saveEmail(payload, (response, err, errorCode) => {
    //         if (err) {
    //           console.error("Failed to save user email on create:", err);
    //         }
    //       });
    //     }

    //     appData.setAssetInfo({
    //       assetId: createdAssetId,
    //       assetName: genericInfo.bannerNameInput,
    //     });

    //     window.localStorage.setItem("assetId", createdAssetId);

    //     history.push({
    //       pathname: `/banner-editor/${createdAssetId}`,
    //       state: {
    //         createBanner: moduleInfo.assetType,
    //         newBanner: true,
    //         brandName: responses?.[0]?.data?.brandName || "",
    //         countryName: responses?.[0]?.data?.marketName || "",
    //       },
    //     });
    //     setLoader(false);
    //   })
    Promise.all(arr)
      .then((responses) => {
        // keep your existing logic for opening the editor with the 1st asset
        setGenericInfo(responses[0].data);
        appData.updateGenericInfo({
          ...appData?.genericInfo,
          ...responses[0].data,
        });

        const email = window.localStorage.getItem("userEmail");

        // ✅ save email for ALL created assets (all sizes)
        if (email) {
          const assetIds = responses
            .map((r) => r?.data?.assetId)
            .filter(Boolean);

          assetIds.forEach((assetId) => {
            saveEmail(
              { assetId, email, update: false },
              (response, err, errorCode) => {
                if (err) {
                  console.error("Failed to save user email:", assetId, err);
                }
              },
            );
          });
        }

        const createdAssetId = responses?.[0]?.data?.assetId;

        appData.setAssetInfo({
          assetId: createdAssetId,
          assetName: genericInfo.bannerNameInput,
        });

        window.localStorage.setItem("assetId", createdAssetId);

        history.push({
          pathname: `/banner-editor/${createdAssetId}`,
          state: {
            createBanner: moduleInfo.assetType,
            newBanner: true,
            onetimeBanner: false,
            brandName: responses?.[0]?.data?.brandName || "",
            countryName: responses?.[0]?.data?.marketName || "",
          },
        });

        setLoader(false);
      })
      .catch(({ err, errorCode }) => {
        const errComponent = ErrComponentToRender(errorCode);
        if (err.response?.data?.errorCode === "ERR_CS_ASSETNAME_EXISTS") {
          toast.error(
            <div className="notificationText">
              {t("apiErrors.errBannerExist")}
            </div>,
          );
        } else {
          toast.error(
            <div className="notificationText">{t("apiErrors.err500")}</div>,
          );
        }
        setLoader(false);
      });
  };

  const handleCreateOnetimeBanner = () => {
    fetchAllSizesBanner();

    const isBannerAlreadyCreated = Object.keys(selectedSizes).length !== 0;
    if (isBannerAlreadyCreated) {
      setopenModalOnLoad(false);
      setShowNewBanner(false);
      toast.error(
        <div className="notificationText">Banner Already Created.</div>,
      );
      return;
    }

    if (!nameValidation(genericInfo.bannerNameInput, "Banner")) return;
    if (!selectedBrandName?.brandDamId || !selectedMarketName?.countryDamId) {
      const errorMessage =
        !selectedBrandName?.brandDamId && !selectedMarketName?.countryDamId
          ? `Both Product : ${queryObj?.brand} and Country : ${queryObj?.country} selected in Veeva Vault does not exist in Content Studio.`
          : !selectedBrandName?.brandDamId
            ? `Product : ${queryObj?.brand} selected in Veeva Vault does not exist in Content Studio.`
            : `Country : ${queryObj?.country} selected in Veeva Vault does not exist in Content Studio.`;

      toast.error(<div className="notificationText">{errorMessage}</div>);
      return;
    }

    setLoader(true);

    const moduleInfo = {
      assetType: "BANNER",
      brandName: selectedBrandName?.brandName,
      brandId: selectedBrandName?.brandDamId,
      marketCode: selectedMarketName?.countryDamId,
      marketName: selectedMarketName?.marketName,
      createdByEmail,
      isAnimated: genericInfo.bannerType === "Animated Banner",
      damDocNumber: queryObj?.promomatsDocId,
    };

    const createOnetimeBannerEditor = (payload) => {
      return new Promise((resolve, reject) => {
        createOnetimeBanner(payload, (response, err, errorCode) => {
          if (err) {
            toast.error(
              <div className="notificationText">Failed to create banner</div>,
            );
            return reject({ err, errorCode });
          }
          resolve(response?.data);
        });
      });
    };

    const promises = [];

    for (let i = 0; i < genericInfo?.bannerSize?.length; i++) {
      const match = genericInfo.bannerSize[i].match(/\d{2,4}×\d{2,4}/);

      if (match) {
        const [width, height] = match[0].split("×");

        const payload = {
          ...moduleInfo,
          width,
          height,
          assetName: `${
            genericInfo?.bannerNameInput?.trim() || "Banner"
          }_${width}x${height}`,
        };
        if (!nameValidation(payload.assetName, "Banner")) {
          setLoader(false);
          return;
        }

        promises.push(createOnetimeBannerEditor(payload));
      }
    }

    Promise.all(promises)
      .then((responses) => {
        const firstAsset = responses?.[0];

        setGenericInfo(firstAsset);

        appData.updateGenericInfo({
          ...appData?.genericInfo,
          ...firstAsset,
        });

        const email = window.localStorage.getItem("userEmail");

        if (email) {
          const assetIds = responses.map((r) => r?.assetId).filter(Boolean);

          assetIds.forEach((assetId) => {
            saveEmail({ assetId, email, update: false }, (response, err) => {
              if (err) {
                console.error("Failed to save email:", assetId);
              }
            });
          });
        }

        const createdAssetId = firstAsset?.data?.assetId;
        appData.setAssetInfo({
          assetId: createdAssetId,
          assetName: genericInfo.bannerNameInput,
        });

        window.localStorage.setItem("assetId", createdAssetId);

        history.push({
          pathname: `/banner-editor/${createdAssetId}`,
          state: {
            createBanner: moduleInfo.assetType,
            newBanner: false,
            onetimeBanner: true,
            brandName: firstAsset?.brandName || "",
            countryName: firstAsset?.marketName || "",
          },
        });

        setLoader(false);
      })
      .catch(({ err }) => {
        if (err?.response?.data?.errorCode === "ERR_CS_ASSETNAME_EXISTS") {
          toast.error(
            <div className="notificationText">
              {t("apiErrors.errBannerExist")}
            </div>,
          );
        } else {
          toast.error(
            <div className="notificationText">{t("apiErrors.err500")}</div>,
          );
        }

        setLoader(false);
      });
  };
  const fetchBannerdetailsFromVeeva = () => {
    setLoader(true);
    getBannerdetailsfromVeeva(queryObj?.promomatsDocId, (response, err) => {
      if (response.status === 200) {
        setLoader(false);
        setGenericInfo({ ...genericInfo, bannerNameInput: response.data });
      } else {
        setLoader(false);
        toast.error(
          <div className="notificationText">
            {`Failed to fetch banner name`}
          </div>,
        );
      }
    });
  };
  useEffect(() => {
    fetchBannerdetailsFromVeeva();
  }, []);
  const handleSwitchComp = (e, type) => {
    const newChecked = e.target.checked;

    setSelectOnetimecontent(newChecked);
    return newChecked;
  };

  useEffect(() => {
    const element = textRef.current;
  
    if (!element) return;
  
    const checkOverflow = () => {
      const element = textRef.current;
    
      if (!element || !element.isConnected) return;
    
      const computedStyle = window.getComputedStyle(element);
    
      const paddingLeft = parseFloat(computedStyle.paddingLeft) || 0;
    
      const paddingRight = parseFloat(computedStyle.paddingRight) || 0;
    
      const contentWidth = element.clientWidth - paddingLeft - paddingRight;
    
      const range = document.createRange();
      range.selectNodeContents(element);
    
      const textWidth = range.getBoundingClientRect().width;
    
      if (contentWidth <= 0 || textWidth <= 0) return;
    
      const isOverflowing = textWidth > contentWidth;
  
      setShowTooltip(isOverflowing);
    };
  
    checkOverflow();
  
    const resizeObserver = new ResizeObserver(checkOverflow);
    resizeObserver.observe(element);
  
    document.fonts?.ready.then(checkOverflow);
  
    return () => {
      resizeObserver.disconnect();
    };
  }, [genericInfo?.bannerNameInput]);

  return (
    <>
      <Dialog
        open={showNewBanner}
        onClose={closeNewBannerModal}
        className="newTemplateModal"
        aria-labelledby="form-dialog-title"
        overlaystyle={{ backgroundColor: "transparent" }}
      >
        {loader && (
          <>
            <div className="modal-backdrop fade show"> </div>
            <CircularProgress
              size="30px"
              className="customLoadermodules"
            />{" "}
          </>
        )}
        <div className="row newBnrModal">
          <div
            className="baseOnModalHeading col-md-6 createbannerhead customScrollBar"
            style={{ fontFamily: "'Nunito Sans', sans-serif" }}
          >
            <p>{t("METADATA INFORMATION")}</p>
            <div className="details newbnr">
              <p className="sourcetag">Banner Name:</p>
              {showTooltip ? (
                <Tooltip title={genericInfo?.bannerNameInput}>
                  <p ref={textRef} className="tagDescription bannerNamevalue">
                    {genericInfo?.bannerNameInput}
                  </p>
                </Tooltip>
              ) : (
                <p ref={textRef} className="tagDescription bannerNamevalue">
                  {genericInfo?.bannerNameInput}
                </p>
              )}
            </div>
            <div className="details newbnr">
              <p className="sourcetag">Source:</p>
              <p className="tagDescription">PromoMats</p>
              {/* <hr className="custom-hr" /> */}
            </div>
            <div className="details newbnr">
              <p className="sourcetag">Created by:</p>
              <p className="tagDescription">{createdByName}</p>
            </div>
            <div className="details newbnr">
              <p className="sourcetag">Created on:</p>
              <p className="tagDescription">{formattedDate}</p>
            </div>
            <div className="details newbnr">
              <p className="sourcetag">PromoMats Material Doc ID:</p>
              <p className="tagDescription">
                {queryObj?.promomatsDocId || "-"}
              </p>
            </div>
            <div className="details newbnr">
              <p className="sourcetag">Product:</p>
              <p className="tagDescription">
                {selectedBrandName?.brandName || "-"}
              </p>
            </div>
            <div className="details newbnr">
              <p className="sourcetag">Country:</p>
              <p className="tagDescription">
                {selectedMarketName?.marketName || "-"}
              </p>
            </div>
          </div>

          <div className="col-md-6 selectBrands customScrollBar">
            <div className="newInputFieldTemp ">
              <DropDownWithLabelTemplate
                options={{
                  value: genericInfo.bannerType || "",
                  name: "bannerType",
                  label: (
                    <>
                      {t("bannerManager.bannerType")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </>
                  ),

                  items: bannerType,
                  handleChange: handleChange,
                  className: "testBannersize",
                }}
              />
            </div>
            {genericInfo?.bannerSizeType === "Pre-defined" && (
              <div
                className={
                  genericInfo?.bannerSizeType === "Pre-defined"
                    ? "newSizeInputFieldTemp chooseSize newInputFieldTemp newSizeInputFieldTempWidth"
                    : "newSizeInputFieldTemp chooseSize2 newInputFieldTemp newSizeInputFieldTempWidth"
                }
              >
                <SizeDropdown
                  options={{
                    disabled: disableSize,
                    value: bannerSize || [],
                    name: "bannerSize",
                    label: (
                      <>
                        {t("Choose Size")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </>
                    ),
                    items: numericBannerSizes,
                    selectedItems: selectedSizes,
                    handleChange: handleChange,
                    className: "testBannersize",
                  }}
                />
              </div>
            )}
            <div className="otContentText">
              One time content
              {/* <Switch
                checked={selectOnetimecontent}
                onChange={(e) => {
                  handleSwitchComp(e);
                  // handleOpenModal("rulesets");
                }}
                style={{
                  //  width: 26,
                  //height: 15,
                  // padding: 0,
                  display: "flex",
                  //marginLeft: "10px",
                }}
                classes={{
                  thumb: "customSwitchThumb",
                  switchBase: "customSwitchBase",
                  track: "customSwitchTrack",
                }}
              /> */}
              <Tooltip
                style={{ marginLeft: "5px" }}
                title={"All banner created are One time content banners"}
              >
                <img src={warning} alt="Warning" />
              </Tooltip>
            </div>
          </div>
        </div>

        <DialogActions
          className="modalActions templateBtn"
          style={{ justifyContent: "flex-end" }}
        >
          <Button
            onClick={() => {
              closeNewBannerModal();
              handleFormReset();
              setopenModalOnLoad(false);
            }}
            color="primary"
            className="cancelBtntemp"
            style={{ marginRight: "16px" }}
          >
            {t("bannerManager.cancel")}
          </Button>
          <Button
            //  onClick={handleGoToEditorScreen}
            onClick={
              selectOnetimecontent
                ? handleCreateOnetimeBanner
                : handleGoToEditorScreen
            }
            type="submit"
            style={{
              fontFamily: "'Nunito Sans', sans-serif",
            }}
            className="temp-btn"
            disabled={!validateForm()}
            autoFocus
          >
            {t("create banner")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
